import apiClient, { unwrapData } from "./apiClient";

export async function searchWorkspace(params = {}, options = {}) {
  const response = await apiClient.get("/api/workspace-search", {
    ...options,
    query: {
      q: params.q,
      limit: params.limit,
      types: params.types,
    },
  });
  const data = unwrapData(response) || {};

  return {
    items: Array.isArray(data.items) ? data.items : [],
  };
}
